import React, { useState } from "react";
import apiClient from "../api.js";

const PropertiesOrder = () => {
  const [selectedArea, setSelectedArea] = useState("");
  const [properties, setProperties] = useState([]);
  const [selectedProperties, setSelectedProperties] = useState([]);

  const areas = [
    "Andheri",
    "Dhankawadi",
    "Hadapsar",
    "Goregaon",
    "Malad",
    "Borivali",
    "Dahisar",
    "Mira Road",
    "Chembur Wadala",
    "Mulund",
    "Vikroli",
    "Bhandup",
    "kanjurmarg",
    "Koparkhairane",
    "Kurla",
    "Ghatkoper",
    "South Bombay",
    "Airoli",
    "Ghansoli",
    "Juinager Nerul Sanpada",
    "Vashi",
    "Kharghar",
    "Taloja",
    "Seawoods",
    "Panvel",
    "Ulwe",
    "Kandivali",
    "Dombivali",
    "Worli",
    "Wadala Sion",
    "Dadar",
    "Shahad",
    "Ambernath",
    "Badlapur",
    "Titwala",
    "Neral",
    "Karjat",
    "Kiwale",
    "Khopoli",
    "Lower Parel",
    "Vasai",
    "Virar",
    "Naigaon",
    "Palghar",
    "Boisar",
    "Thane",
    "Chembur",
    "Vadala",
    "Kalyan",
    "Moshi",
    "Talegaon Dabhade",
    "Charholi Budruk",
    "Chikhali",
    "Alandi",
    "Chakan",
    "Bhosari",
    "Chinchwad",
    "Dehu",
    "Nigdi",
    "Baner",
    "Ravet",
    "Hinjawadi",
    "Tathawade",
    "Bavdhan",
    "Wakad",
    "Punawale",
    "Balewadi",
    "Pirangut",
    "Mahalunge",
    "Rahatani",
    "Mohammed Wadi",
    "Ambegaon BK",
    "Kondhwa Budruk",
    "Kondhwa",
    "Parvati",
    "Pashan",
    "Katraj",
    "Dhayari",
    "Lonikand",
    "Undri",
    "Saswad",
    "Wagholi",
    "Kharadi",
    "Lohegaon",
    "Dhanori",
    "Mundhwa",
    "Manjri",
    "Wadgaon Sheri",
    "Keshav Nagar",
    "Kesnand",
    "Kothrud",
    "Shivaji Nagar",
    "Sangamvadi",
    "Pimpri",
    "Pimpri Nilakh",
    "Erandwane",
    "Sadashiv Peth",
    "Gultekdi",
    "Deccan",
    "Kasba Peth",
    "Karve Nagar",
    "Ulhasnagar",
    "Dattawadi",
    "Nana Peth",
    "Sus",
  ];

  const handleSelectChange = (event) => {
    setSelectedArea(event.target.value);
  };

  const handlePropertySelect = (property) => {
    setSelectedProperties((prevSelected) => {
      if (prevSelected.includes(property)) {
        return prevSelected.filter((p) => p !== property);
      } else if (prevSelected.length < 3) {
        return [...prevSelected, property];
      } else {
        alert("You can only select up to three properties.");
        return prevSelected;
      }
    });
  };

  const handleSubmit = async () => {
    if (selectedArea) {
      try {
        const response = await apiClient.get(
          `listing/properties/${selectedArea}`,
        );
        setProperties(response.data);
      } catch (error) {
        console.error("Error fetching properties:", error);
      }
    }
  };

  const handleSaveSelected = async () => {
    if (selectedProperties.length === 3) {
      try {
        await apiClient.post("listing/displayorder", {
          selectedProperties,
          selectedArea,
        });

        alert("Properties saved successfully!");
        setSelectedProperties([]);
        setProperties([]);
      } catch (error) {
        console.error("Error saving properties:", error);
      }
    } else {
      alert("Please select exactly three properties.");
    }
  };

  return (
    <>
      <div className="container mb-5 mt-5">
        <div className="row">
          <div className="col-md-12">
            <select name="" id="area" onChange={handleSelectChange}>
              {areas.map((area, index) => (
                <option key={index} value={area}>
                  {area}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-12">
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
        <div className="row">
          {properties.map((property, index) => (
            <div key={index} className="col-md-4">
              <div className="property-card">
                <h5>{property.name}</h5>
                <input
                  type="checkbox"
                  checked={selectedProperties.includes(property._id)}
                  onChange={() => handlePropertySelect(property._id)}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="col-md-12">
          <button className="btn btn-primary mt-3" onClick={handleSaveSelected}>
            Save Selected Properties
          </button>
        </div>
      </div>
    </>
  );
};

export default PropertiesOrder;
